import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { ClientUserState } from '../ClientUserState.ts';
export class UIStoreState {
    set items(items) {
        this.storeUI.bodyController.updateOwnedItems(items);
        this.storeUI.bodyController.updatePriceForFounderPack(items);
    }
    get membershipToggleYearlyActive() {
        return this._membershipToggleYearlyActive;
    }
    set membershipToggleYearlyActive(yearlyActive) {
        this._membershipToggleYearlyActive = yearlyActive;
        if (yearlyActive) {
            this.storeUI.bodyController.membershipItems.forEach((item)=>{
                item.productDiv.style.display = item.membershipProduct.billedAnnually ? 'flex' : 'none';
            });
            this.storeUI.bodyController.membershipTabsController.setTabAnnual(true);
            return;
        }
        this.storeUI.bodyController.membershipItems.forEach((item)=>{
            item.productDiv.style.display = item.membershipProduct.billedAnnually ? 'none' : 'flex';
        });
        this.storeUI.bodyController.membershipTabsController.setTabAnnual(false);
    }
    setMembership(membership, paymentMethod) {
        this.storeUI.bodyController.updateOwnedMembership(membership, paymentMethod);
        this.storeUI.bodyController.updateSubscribedItems(membership, paymentMethod);
        const toggleYearlyActive = membership === undefined ? true : ColonistMembershipProduct.isAnnualMembership(membership.type);
        this.membershipToggleYearlyActive = toggleYearlyActive;
    }
    set giftedMembershipItems(giftedMembershipItems) {
        this.storeUI.bodyController.updateGiftedMemberships(giftedMembershipItems);
    }
    updateUserStoreState(userState) {
        var _userState_items_getItems;
        this.items = (_userState_items_getItems = userState === null || userState === void 0 ? void 0 : userState.items.getItems()) !== null && _userState_items_getItems !== void 0 ? _userState_items_getItems : [];
        const currentMembership = userState === null || userState === void 0 ? void 0 : userState.items.membership;
        this.setMembership(currentMembership != undefined ? ColonistMembershipProduct.getMembershipProduct(currentMembership) : undefined, userState === null || userState === void 0 ? void 0 : userState.items.membershipPaymentMethod);
        var _userState_items_giftedMemberships;
        this.giftedMembershipItems = (_userState_items_giftedMemberships = userState === null || userState === void 0 ? void 0 : userState.items.giftedMemberships) !== null && _userState_items_giftedMemberships !== void 0 ? _userState_items_giftedMemberships : [];
    }
    constructor(storeUI){
        this._membershipToggleYearlyActive = true;
        this.storeUI = storeUI;
        setTimeout(()=>{
            ClientUserState.registerChangeListener((userState)=>{
                this.updateUserStoreState(userState);
            });
        }, 1);
    }
}
